






















































import { Component, Vue } from "vue-property-decorator";
import { Step, Steps } from "vant";
import NetErrorPage from "@/components/NetErrorPage.vue";

@Component({
  name: "CheckProgress",
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    NetErrorPage: NetErrorPage
  }
})
export default class CheckProgress extends Vue {
  showPage = false;
  acceptance_sn = "";
  created_at = "";
  is_verify = "";

  isLoading = true;
  requestFail = true;

  get bgColor() {
    return this.$store.getters["common/bgColor"];
  }

  created() {
    this.getAccountProgress();
  }
  getAccountProgress() {
    this.isLoading = true;
    (this as any).$apis
      .getAccountProgress()
      .then(res => {
        this.requestFail = false;
        const { acceptance_sn, created_at, is_verify } = res;
        this.acceptance_sn = acceptance_sn;
        this.created_at = created_at;
        this.is_verify = is_verify;
      })
      .catch(e => {
        this.requestFail = true;
        
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
}
